import Api from "../config/api";

export const calcularValorTotalFindAllOrcamento = async (variables) => {
  const response = await Api.post("", {
    query: `
    query (
      $dataAgendamentoInicio: LocalDate, 
      $dataAgendamentoFim: LocalDate, 
      $tipo: OrcamentoTipo, 
      $tipos: [OrcamentoTipo], 
      $search: String, 
      $sujeitoAtencaoId: UUID, 
      $dataHoraLancamentoInicio: LocalDateTime, 
      $dataHoraLancamentoFim: LocalDateTime, 
      $statusOrcamentoOdontologicoId: UUID, 
      $numero: Long, 
      $profissionalSolicitanteId: Long, 
      $status: [OrcamentoStatus],
      $faturado: Boolean,
      $orcamentistaId: Long,
      $executanteId: Long
      $dataFaturamentoInicio: LocalDate,
      $dataFaturamentoFim: LocalDate
    ) {
      calcularValorTotalFindAllOrcamento(
        dataAgendamentoInicio: $dataAgendamentoInicio, 
        dataAgendamentoFim: $dataAgendamentoFim, 
        tipo: $tipo,
        tipos: $tipos, 
        search: $search, 
        sujeitoAtencaoId: $sujeitoAtencaoId, 
        dataHoraLancamentoInicio: $dataHoraLancamentoInicio, 
        dataHoraLancamentoFim: $dataHoraLancamentoFim, 
        statusOrcamentoOdontologicoId: $statusOrcamentoOdontologicoId, 
        numero: $numero, 
        profissionalSolicitanteId: $profissionalSolicitanteId, 
        status: $status,
        faturado: $faturado,
        orcamentistaId: $orcamentistaId,
        executanteId: $executanteId,
        dataFaturamentoInicio: $dataFaturamentoInicio,
        dataFaturamentoFim:$dataFaturamentoFim
      )
    }`,
    variables: {
      ...variables,
    },
  });
  if (!response.data.errors) {
    return response.data.data.calcularValorTotalFindAllOrcamento;
  } else {
    throw response.data.errors[0];
  }
};

export const findAllOrcamentoOdontologicoProcedimento = async (variables) => {
  const response = await Api.post("", {
    query: `
      query (
        $dataAgendamentoInicio: LocalDate, 
        $dataAgendamentoFim: LocalDate, 
        $tipo: OrcamentoTipo, 
        $tipos: [OrcamentoTipo], 
        $search: String, 
        $sujeitoAtencaoId: UUID, 
        $dataHoraLancamentoInicio: LocalDateTime, 
        $dataHoraLancamentoFim: LocalDateTime, 
        $pageableDTO: PageableDTOInput, 
        $statusOrcamentoOdontologicoId: UUID, 
        $numero: Long, 
        $profissionalSolicitanteId: Long, 
        $status: [OrcamentoStatus],
        $faturado: Boolean,
        $orcamentistaId: Long,
        $executanteId: Long,
        $dataFaturamentoInicio: LocalDate,
        $dataFaturamentoFim: LocalDate
      ) {
        findAllOrcamento(
          dataAgendamentoInicio: $dataAgendamentoInicio, 
          dataAgendamentoFim: $dataAgendamentoFim, 
          tipo: $tipo, 
          tipos: $tipos, 
          search: $search, 
          sujeitoAtencaoId: $sujeitoAtencaoId, 
          dataHoraLancamentoInicio: $dataHoraLancamentoInicio, 
          dataHoraLancamentoFim: $dataHoraLancamentoFim, 
          pageableDTO: $pageableDTO, 
          statusOrcamentoOdontologicoId: $statusOrcamentoOdontologicoId, 
          numero: $numero, 
          profissionalSolicitanteId: $profissionalSolicitanteId, 
          status: $status,
          faturado: $faturado,
          orcamentistaId: $orcamentistaId,
          executanteId: $executanteId,
          dataFaturamentoInicio: $dataFaturamentoInicio,
          dataFaturamentoFim:$dataFaturamentoFim
      ) {
        last
        content {
          id
          numero
          tipo
          agendamento {
            id
            data
          }
          dataHoraLancamento
          valorTotalLiquido
          statusOrcamentoOdontologico {
            nome
            tipo
          }
          historico {
            informacao
            dataHoraLancamento
          }
          sujeitoAtencao {
            nome
          }
          profissionalSolicitante {
            nome
          }
          orcamentista {
            nome
          }
          status
          convenio {
            descricao
          }
          faturado
        }
      }
    }`,
    variables: {
      ...variables,
    },
  });
  if (!response.data.errors) {
    return response.data.data.findAllOrcamento;
  } else {
    throw response.data.errors[0];
  }
};

export const findAllSujeitoAtencao = async (id) => {
  const response = await Api.post("", {
    query: `
    query ($searchDTO: SearchSujeitoAtencaoDTOInput){
      findAllSujeitoAtencao(searchDTO: $searchDTO) {
        last
        content {
          id
          nome
        }
      }
    }`,
    variables: variables,
  });

  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  }
  return response.data.data.findAllSujeitoAtencao;
};

export const findAllHistoricoOrcamentoOdontologico = async (orcamentoId) => {
  const response = await Api.post("", {
    query: `
    query ($orcamentoId: UUID){
      findAllHistoricoOrcamentoOdontologico(orcamentoId: $orcamentoId) {
        id
        informacao
        dataHoraLancamento
        profissionalSaude {
          nome
        }
      }
    }`,
    variables: { orcamentoId },
  });

  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  }
  return response.data.data.findAllHistoricoOrcamentoOdontologico;
};
